export default ([name, surname]) => {
    let res = [name, surname].filter(Boolean).join(' ');
    if (res.length > 16) {
        res = name;
    }
    return res;
};
